import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Public routes that must render even when the session probe returns 401.
const PUBLIC_PATHS = ["/login", "/register", "/forgot-password", "/reset-password"];

// httpOnly cookie based auth: withCredentials sends the access_token cookie automatically.
const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      const path = typeof window !== "undefined" ? window.location.pathname : "";
      const url = err?.config?.url || "";
      const isPublicRoute = PUBLIC_PATHS.some((p) => path === p || path.startsWith(p + "/"));
      const isMeProbe = url.endsWith("/auth/me");
      // Never bounce anonymous visitors off public routes, and never let the
      // AuthContext /auth/me hydration probe cause a redirect.
      if (!isPublicRoute && !isMeProbe && path !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
